import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState, useRef, useContext } from "react";
import { AuthContext } from "../Provider/AuthProvider";
import { security } from "../env/Environment";
import { useMediaQuery } from "react-responsive";
import { Ajax } from "../Service/ajax";
import Swal from "sweetalert2";

export default function NavBar({ route }) {
    const { logout } = useContext(AuthContext);
    const session = sessionStorage.getItem("session");
    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery({ maxWidth: 575 });
    const { pageUrl } = useParams();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [user, setUser] = useState(null);
    const dropdownRef = useRef(null); // ← Ref pour détecter les clics en dehors

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const fetchData = async () => {
        try {
            const { data } = await Ajax.getRequest("/api/v1/sub/subscription/isSubscribe/organisation/" + security.ntk_sub_cmp);
            if (data.error || data.object.status !== "ACTIVE") {
                Swal.fire({
                    title: 'Message important',
                    text: "Vous n'avez aucun abonnement actif sur subscribe, abonnez-vous pour accéder à l'espace business de subscribe",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#debf66',
                    focusConfirm: true,
                    confirmButtonText: 'Continuer',
                    cancelButtonText: 'Annuler'
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate("/");
                    }
                });
            } else {
                sessionStorage.setItem("trf", JSON.stringify(data.object));
                navigate("/organisation");
            }
        } catch (error) {
            navigate("/error-page", { state: { errorCode: error.response.status } });
        }
    };

    const changeState = () => {
        if (route.toLowerCase() === "organisation") {
            fetchData();
        } else {
            navigate("/" + route.toLowerCase());
        }
        setDropdownOpen(false); // Ferme le menu après clic
    };

    const handleLogout = () => {
        logout();
        window.location.replace(
            sessionStorage.getItem("rememberMe") ? window.location.origin : security.serverLogoutEndpoint
        );
    };

    const prtLogout = () => {
        logout();
        if (!sessionStorage.getItem("rememberMe")) {
            window.location.replace(security.serverLogoutEndpoint);
        }
    };

    const handleLogin = () => {
        let location = window.location.origin + "/";
        if (location === window.location.href) {
            navigate("/login?target=login");
        } else {
            navigate(`/login?target=own-page&target_id=${pageUrl}`);
        }
    };

    useEffect(() => {
        const fetchUser = async () => {
            const { data } = await Ajax.getRequest(`/api/v1/usr/users/session`);
            setUser(data.phone);
        };
        if (session) {
            fetchUser();
        }
    }, [session]);

    // ← Fermer le dropdown si clic en dehors
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        if (dropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownOpen]);

    return (
        <nav className="navbar navbar-example bg-light layout-navbar-fixed shadow-sm py-2">
            <div className="container-fluid d-flex justify-content-between align-items-center">
                <a type="button" className="display-7 text-black fw-bolder text-decoration-none" onClick={() => navigate("/")}>
                    <img src={require("../assets/img/illustrations/Netikash subscribe-2.png")} alt="Netikash Logo" className="mb-2" style={{ width: 150 }} />
                </a>

                <div className="position-relative" ref={dropdownRef}>
                    <button
                        className="navbar-toggler d-flex flex-column align-items-end border-0 bg-transparent"
                        type="button"
                        onClick={session ? toggleDropdown : handleLogin}
                        style={{ zIndex: 9999 }}
                    >
                        <div className="d-flex align-items-center">
                            <i className="tf-icons bx bx-user-circle me-2" style={{ fontSize: "1.8rem", color: "#000" }}></i>
                            {user ? (
                                <span style={{ fontSize: "1rem", color: "#000" }}>+{user.fullNumber}</span>
                            ) : (
                                <span style={{ fontSize: "1rem", color: "#000" }}>Se Connecter</span>
                            )}
                            <i className={`bx ${dropdownOpen ? 'bx-chevron-up' : 'bx-chevron-down'} me-2`}></i>
                        </div>
                        {route && (
                            <div className="d-flex align-items-center mt-1">
                                <i className="bx bx-map me-1 text-warning"></i>
                                <small className="fw-semibold text-muted">{route.toLowerCase() === 'organisation' ? 'particulier' : 'organisation'}</small>
                            </div>
                        )}
                    </button>

                    {dropdownOpen && (
                        <div className="dropdown-menu show end-0 mt-2 p-3 shadow rounded"
                             style={{
                                 position: "absolute",
                                 top: "100%",
                                 right: 0,
                                 minWidth: "250px",
                                 backgroundColor: "#fff",
                                 zIndex: 9999
                             }}>
                            <ul className="list-unstyled mb-3">
                                <li className="mb-2 d-flex align-items-center">
                                    <i className="bx bx-support me-2 text-primary"></i>
                                    <button className="btn btn-sm text-start text-dark fw-medium bg-transparent p-0"
                                            onClick={() => window.open("https://support.netikash.com", "_blank")}>
                                        Support
                                    </button>
                                </li>
                                <li className="mb-2 d-flex align-items-center">
                                    <i className="bx bx-phone me-2 text-success"></i>
                                    <button className="btn btn-sm text-start text-dark fw-medium bg-transparent p-0"
                                            onClick={() => window.open("https://akiba.netikash.com/contact", "_blank")}>
                                        Contactez-Nous
                                    </button>
                                </li>
                                {route && session && (
                                    <li className="mb-2 d-flex align-items-center">
                                        <button type="button" className="btn btn-sm text-start text-dark fw-medium bg-transparent p-0" onClick={changeState}>
                                            <i className="bx bx-user me-2"></i>
                                            Changer de profil
                                            <i className="bx bx-transfer-alt ms-2"></i>
                                        </button>
                                    </li>
                                )}
                                <li className="mb-2 d-flex align-items-center">
                                    {session ? (
                                        <button type="button" className="btn btn-danger btn-sm w-100 d-flex align-items-center justify-content-center rounded-pill"
                                                onClick={route ? handleLogout : prtLogout}>
                                            <i className="bx bx-log-out-circle me-2"></i>
                                            {isSmallScreen ? '' : "Se Déconnecter"}
                                        </button>
                                    ) : (
                                        <button type="button" className="btn btn-outline-primary btn-sm w-100 d-flex align-items-center justify-content-center rounded-pill"
                                                onClick={handleLogin}>
                                            <i className="bx bx-log-in-circle me-2"></i>
                                            {isSmallScreen ? '' : "Se Connecter"}
                                        </button>
                                    )}
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
}
